import { FlightAlternatives, CombinationOffer } from '@tff/types/tff';
import AlternativeFlightCard from './AlternativeFlightCard';
import React, { SetStateAction } from 'react';
import TFFTypography from '../../../../styled-components/TFFTypography';
import * as TFF from '@tff/types/tff';
import { useIntl } from 'react-intl';
import { isNewJourneySameAsOriginal } from '../../Utils/isOriginalBookingJourney';

interface AlternativeFlightCardsProps {
  journeys: TFF.Journey[];
  flightAlternatives?: FlightAlternatives;
  selectedOffer: CombinationOffer | undefined;
  setSelectedOffer: (offer: CombinationOffer) => void;
  setSelectedOfferJourneys: (value: SetStateAction<TFF.Journey[]>) => void;
}

const AlternativeFlightCards: React.FC<AlternativeFlightCardsProps> = ({
  journeys,
  flightAlternatives,
  selectedOffer,
  setSelectedOffer,
  setSelectedOfferJourneys,
}) => {
  const intl = useIntl();

  const journeyMap = new Map(flightAlternatives?.Journeys.map(journey => [journey.Id, journey]));

  const filteredCombinationOffers = Object.entries(flightAlternatives?.CombinationOffers || {}).filter(
    ([combinationOfferKey]) => {
      const [outboundJourneyId, inboundJourneyId] = combinationOfferKey.split('-');
      const outboundJourney = journeyMap.get(outboundJourneyId);
      const inboundJourney = journeyMap.get(inboundJourneyId);

      return (
        (outboundJourney && !isNewJourneySameAsOriginal(journeys[0], outboundJourney)) ||
        (inboundJourney && !isNewJourneySameAsOriginal(journeys[1], inboundJourney))
      );
    },
  );

  return (
    <div style={{ width: '100%' }}>
      <div style={{ margin: '16px 0' }}>
        <TFFTypography
          text={`${intl.formatMessage({ id: 'ndc.rebookAlternativeFlightResults' })}`}
          modifier="uppercase"
          color="color-theme-variant"
          fontWeight="bold"
          size="large"
        />
      </div>
      {filteredCombinationOffers.map(([combinationOfferKey, offerData]) => {
        const [outboundJourneyId, inboundJourneyId] = combinationOfferKey.split('-');
        const outboundJourney = journeyMap.get(outboundJourneyId);
        const inboundJourney = journeyMap.get(inboundJourneyId);

        const fareOffers: CombinationOffer[] | undefined =
          flightAlternatives?.CombinationOffers?.[combinationOfferKey]?.Offers;

        return outboundJourney ? (
          <AlternativeFlightCard
            key={combinationOfferKey}
            outboundJourney={outboundJourney}
            inboundJourney={inboundJourney}
            fareOffers={fareOffers?.sort((a, b) => a.TotalAmount - b.TotalAmount)}
            selectedOffer={selectedOffer}
            ancillaries={flightAlternatives?.Ancillaries}
            handleOfferClick={(offer: CombinationOffer) => {
              setSelectedOffer(offer);
              setSelectedOfferJourneys(
                inboundJourney
                  ? [
                      {
                        ...outboundJourney,
                        CabinClassName: offer.PriceClasses.Journeys[outboundJourney.Id] as TFF.CabinClassName,
                      },
                      {
                        ...inboundJourney,
                        CabinClassName: offer.PriceClasses.Journeys[inboundJourney.Id] as TFF.CabinClassName,
                      },
                    ]
                  : [
                      {
                        ...outboundJourney,
                        CabinClassName: offer.PriceClasses.Journeys[outboundJourney.Id] as TFF.CabinClassName,
                      },
                    ],
              );
            }}
          />
        ) : null;
      })}
    </div>
  );
};

export default AlternativeFlightCards;
